export default __webpack_public_path__ + "static/media/white_euro.74c013b5.svg";